import { BaggageType } from '@websky/graphql';
export const getIsBaggagePet = (baggageType) => {
    return [BaggageType.PetInCabin, BaggageType.PetInHandCarrier, BaggageType.PetInHold].includes(baggageType);
};
